
import { defineComponent } from 'vue';

export default defineComponent({
  emits: ['cancel', 'done'],
});
